<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaInspectDeviceInput',
})
</script>
<template>
	<el-input v-model="userName" :clearable :disabled :placeholder @clear="model = ''">
		<template #append>
			<el-button icon="Search" @click="visible = true" />
		</template>
	</el-input>
	<ma-inspect-device-dialog v-if="!disabled && visible" :key="visible" v-model="visible" :multiple @select="userHandle"></ma-inspect-device-dialog>
</template>

<script setup lang="ts" name="MaInspectDeviceInput">
import { ref, watch } from 'vue'
// import { useRealNameListApi } from '@/api/sys/user'
import { apiRequest } from '@/api/common'
const props = defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	}
})

const model = defineModel<any | any[]>()
const visible = ref(false)
const userName = ref()

watch(
	() => model.value,
	async val => {
		if (val) {
			if (props.multiple && typeof val === 'string') {
				val = val.split(',')
			}
			const idList = val
			if (idList.length > 0) {
				apiRequest('POST', '/maku/biz_inspect_device/deviceNameList', props.multiple ? idList : [idList]).then(res => {
					userName.value = res.data.join(',')
				})
			}
		} else {
			userName.value = ''
		}
	},
	{
		immediate: true
	}
)
// watch(
// 	() => model.value,
// 	async val => {
// 		if (val) {
// 			const idList = props.multiple ? val : [val]
// 			if (idList.length > 0) {
// 				// const { data } = await useRealNameListApi(idList)

// 				// userName.value = data.join(',')
// 				userName.value = val
// 			}
// 		} else {
// 			userName.value = ''
// 		}
// 	},
// 	{
// 		immediate: true
// 	}
// )

const emit = defineEmits(['select', 'change'])
const userHandle = (rows: any[]) => {
	if (props.multiple) {
		model.value = rows.map((item: any) => item.id)
	} else {
		model.value = rows[0].id
	}
	emit('select', rows)
	emit('change', rows)
}
const getDeviceList = () => {
	// apiRequest('post', '')
}
</script>
